import React from 'react'
import classnames from 'classnames'

import { useIsParticipantScreenInFloor } from '../../../../firebase/hooks/useFloor'
import { VideoTrack } from '../../../../MediaTracks/components/VideoTrack/VideoTrack'
import { useParticipant } from '../../../../webrtc/webRTCRoom'

interface FloorCameraFeedProps {
  id: number
}

const FloorScreenFeed = ({ id }: FloorCameraFeedProps) => {
  const isParticipantScreenInFloor = useIsParticipantScreenInFloor(id)
  const participant = useParticipant(id)

  if (!participant?.tracks.screen) return null

  return (
    <div
      className={classnames('participant-screen-track', {
        hide: !isParticipantScreenInFloor,
      })}
    >
      <VideoTrack track={participant.tracks.screen} objectFit="contain" />
    </div>
  )
}

export { FloorScreenFeed }
